import { useTheme } from "styled-components";

const SegmentedToggle = ({ segments = [], onToggle }) => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "inline-flex",
        border: `1px solid ${theme.color.gray50}`,
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      {segments.map((seg, i) => (
        <button
          key={seg.key}
          type="button"
          disabled={seg.disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!seg.disabled) onToggle?.(seg.key, !seg.active);
          }}
          style={{
            border: "none",
            borderInlineStart:
              i === 0 ? "none" : `1px solid ${theme.color.gray50}`,
            padding: "8px 14px",
            fontFamily: "Rubik",
            fontSize: 14,
            fontWeight: 500,
            whiteSpace: "nowrap",
            cursor: seg.disabled ? "not-allowed" : "pointer",
            backgroundColor: seg.active ? theme.color.primary : theme.color.white,
            color: seg.active ? theme.color.white : theme.color.gray90,
            opacity: seg.disabled ? 0.5 : 1,
          }}
        >
          {seg.label}
        </button>
      ))}
    </div>
  );
};

export default SegmentedToggle;
